type T = string;

export const fromLocalNumber = (p: string): T =>
    p.charAt(0) === "0" ? "+44".concat(p.substr(1)) : p;
